import { render, staticRenderFns } from "./AAsignacionProgCobranzaV2.vue?vue&type=template&id=41f2a88c&scoped=true"
import script from "./AAsignacionProgCobranzaV2.vue?vue&type=script&lang=js"
export * from "./AAsignacionProgCobranzaV2.vue?vue&type=script&lang=js"
import style0 from "./AAsignacionProgCobranzaV2.vue?vue&type=style&index=0&id=41f2a88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f2a88c",
  null
  
)

export default component.exports